import React from "react";
import wabes from './styles//images/download.svg';
import './styles/cfss.css';
import PCA_img1 from './styles/images/cffs-img.jpg';
import TestimonialMarquee from "./testimonialmarquee";
import PCA_img2 from './styles/images/cffs-img2.jpg';
import PCA_img3 from './styles/images/cffs-imgp.jpg';
import NewsTicker from "./marequee";
import Cfss_img1 from './styles/images/CFSS-img.jpg';
import Footer from "./Footer";
import Comparison from "./Comparison";
function CFSS() {
    return (
        <>
            <section id="about4" className="about">
                <div className="wrap"></div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 pb-5" id="about-col1">

                            <h1 className="heading">Flexible <span className="hero-highlight">Care</span>  <br /> Greater <span className="hero-highlight">Independence</span></h1>
                            <p className="supporting">
                                Empowering individuals with personalized support to live independently at home.
                            </p>
                        </div>
                    </div>
                </div>
                <img src={wabes} alt="Waves" id="waves1" />
            </section>
            <section id="about-des2">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-7 col-md-6 col-sm-12">
                            <h1>What Is <span className="hero-highlight">CFSS?</span></h1>
                            <p>
                                <strong>Community First Services and Supports (CFSS)</strong> is a flexible home care program similar to PCA, designed to assist seniors, children, and adults with disabilities in living independently in the comfort of their homes.
                            </p>

                            <p><strong>CFSS-MN: What Does This Mean for You?</strong></p>
                            <p>
                                CFSS offers <strong>greater freedom, flexibility, and control</strong> over home care services, ensuring care recipients receive personalized support tailored to their needs.
                            </p>

                            <h5><strong>Key Benefits of CFSS</strong></h5>
                            <ul>
                                <li><strong>Expanded provider options</strong> – More choices in selecting caregivers</li>
                                <li><strong>Greater self-direction</strong> – Increased control over service plans</li>
                                <li><strong>Additional planning support</strong> – Assistance in developing service delivery plans</li>
                                <li><strong>Ability to purchase essential goods</strong> – Access to necessary items that enhance independence</li>
                            </ul>

                            <p>
                                For more details, visit our <a href="/faq"><strong>FAQ section</strong></a> or <a href="/contact-us"><strong>contact Samah Home Care</strong></a> today.
                            </p>
                            <a href="/contact-us" className="nav0cta1">
                                Contact Us
                            </a>


                        </div>
                        <div className="col-lg-5 col-md-6 col-sm-12">
                            <img src={PCA_img1} alt="PCA image of the Samah home Care | Samah Homes" width={'95%'} height={'100%'} className="img-fluid rounded" />
                        </div>
                    </div>
                </div>
            </section>
            <section className="m-5">
                <TestimonialMarquee />
            </section>
            <section id="PCA_links" className="mb-5">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <img src={Cfss_img1} alt=" CFSs image of the Samah home Care | Samah Homes " width={'100%'} className="img-fluid rounded mb-4" />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <h2>Will <span className="hero-highlight">CFSS</span> Replace <span className="hero-highlight">PCA?</span> </h2>

                            <p>
                                Yes, <strong>CFSS</strong> will replace <strong>PCA</strong>, but this change comes with added benefits for care recipients and family caregivers in Minnesota.
                            </p>

                            <p>
                                The eligibility criteria for <strong>CFSS</strong> remain the same as <strong>PCA</strong>, meaning individuals currently receiving PCA services will transition to CFSS during their next annual reassessment—unless there are changes in their condition affecting eligibility.
                            </p>

                            <p>
                                Additionally, the <strong>CFSS</strong> program will replace the state-funded Consumer Support Grant (CSG) benefit.
                            </p>

                        </div>
                    </div>
                </div>
            </section>
            <section id="PCA_links">
                <Comparison />
            </section>
            <section id="about-des2">
                <div className="container">
                    <div className="row mt-5">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <img src={PCA_img3} alt=" An img of a Samah Home care | Samah Home care" width={'100%'} height={'100%'} className="img-fluid rounded rounded mb-4" />

                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <h2>Understanding the <span className="hero-highlight">CFSS</span> Agency Model</h2>
                            <p>
                                With this model, you have the flexibility to choose an agency that acts as the official employer of your support worker. This means the agency handles all administrative tasks, allowing you to focus on what truly matters—your independence and well-being.
                            </p>

                            <h3>What Does the <span className="hero-highlight">Agency Manage</span>?</h3>
                            <ul>
                                <li>Recruiting qualified support workers</li>
                                <li>Hiring and onboarding staff</li>
                                <li>Providing necessary training</li>
                                <li>Supervising support workers</li>
                                <li>Handling payroll and administrative duties</li>
                            </ul>

                            <p>
                                Choosing this model saves you time and effort, freeing you from complex administrative responsibilities so you can enjoy life with peace of mind.
                            </p>

                            <h3>Already Receiving <span className="hero-highlight">Support</span>?</h3>
                            <p>
                                If you're currently receiving services from <strong>Samah Home Care</strong>, great news! You can continue with the same agency under the CFSS agency model. Looking for an agency? <a href="/contact-us"> We’ve got you covered!</a>
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div className="container mb-5">
                <div className="row ">
                    <NewsTicker />
                </div>
                </div>
               

            </section>
            <footer>
                <Footer />
            </footer>
        </>
    )
}
export default CFSS;